import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Supprimer l'erreur ResizeObserver qui apparaît avec les Select/Dropdowns
// C'est une erreur bénigne connue de React qui n'affecte pas la fonctionnalité
const originalConsoleError = console.error;
console.error = (...args) => {
  const firstArg = args[0];
  if (typeof firstArg === 'string' && 
      (firstArg.includes('ResizeObserver loop') || 
       firstArg.includes('ResizeObserver loop completed with undelivered notifications'))) {
    return;
  }
  originalConsoleError(...args);
};

// Supprimer aussi les erreurs non catchées de ResizeObserver
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
